module.exports = __webpack_public_path__ + "images/488497216f23ce9de0aa6a40681c4458.png";